import type { Memo } from '@memori-web/shared';
import { calculateLevel } from './forest-grid.js';

export interface ForestModalCallbacks {
  onSelectDay: (date: string) => void;
}

export function showForestModal(memos: Memo[], todayDate: string, cb: ForestModalCallbacks): Promise<void> {
  return new Promise((resolve) => {
    const counts = new Map<string, number>();
    for (const m of memos.filter(x => !x.deletedAt)) {
      counts.set(m.date, (counts.get(m.date) ?? 0) + 1);
    }
    const today = new Date(todayDate);
    const start = new Date(today);
    start.setDate(today.getDate() - 364);
    // Align start to Sunday (= getDay() === 0)
    const dayOfWeek = start.getDay();
    start.setDate(start.getDate() - dayOfWeek);

    const cells: string[] = [];
    const monthLabels: string[] = [];
    for (let week = 0; week < 53; week++) {
      const colCells: string[] = [];
      for (let day = 0; day < 7; day++) {
        const d = new Date(start);
        d.setDate(start.getDate() + week * 7 + day);
        const ymd = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        const lvl = calculateLevel(counts.get(ymd) ?? 0);
        const isToday = ymd === todayDate;
        colCells.push(`<button class="forest-modal__cell forest-modal__cell--l${lvl} ${isToday ? 'is-today' : ''}" data-date="${ymd}" aria-label="${ymd} ${counts.get(ymd) ?? 0}件"></button>`);
        if (day === 0 && d.getDate() <= 7) {
          monthLabels.push(`<span class="forest-modal__month-label" style="grid-column: ${week + 1}">${d.getMonth() + 1}月</span>`);
        }
      }
      cells.push(`<div class="forest-modal__column">${colCells.join('')}</div>`);
    }

    const root = document.createElement('div');
    root.className = 'forest-modal';
    root.innerHTML = `
      <div class="forest-modal__backdrop"></div>
      <div class="forest-modal__panel" role="dialog" aria-label="1 年の森">
        <header class="forest-modal__header">
          <h2>1 年の森</h2>
          <button type="button" class="forest-modal__close" aria-label="閉じる">✕</button>
        </header>
        <div class="forest-modal__scroll">
          <div class="forest-modal__months">${monthLabels.join('')}</div>
          <div class="forest-modal__grid">${cells.join('')}</div>
        </div>
      </div>
    `;
    document.body.appendChild(root);
    requestAnimationFrame(() => root.classList.add('is-open'));

    // 自動で右端 (現在週) にスクロール
    requestAnimationFrame(() => {
      const scroll = root.querySelector<HTMLDivElement>('.forest-modal__scroll')!;
      scroll.scrollLeft = scroll.scrollWidth;
    });

    const close = () => {
      root.classList.remove('is-open');
      setTimeout(() => { root.remove(); resolve(); }, 200);
    };
    root.querySelector('.forest-modal__backdrop')!.addEventListener('click', close);
    root.querySelector('.forest-modal__close')!.addEventListener('click', close);
    root.querySelectorAll<HTMLButtonElement>('.forest-modal__cell').forEach(btn => {
      btn.addEventListener('click', () => {
        cb.onSelectDay(btn.dataset.date!);
        close();
      });
    });
  });
}
